<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    <ISelectMenu [(value)]="selectedOrganization" by="id" fitTriggerWidth>
      <ISelectTrigger class="flex w-full">
        <ISelectValue>
          <div *iSelectValue="let value">{{ value?.organizationName }}</div>
        </ISelectValue>
      </ISelectTrigger>
      <ISelectContent>
        @for (organization of organizations(); track organization.id) {
          <ISelectOption [value]="organization">
            {{ organization.organizationName }}
          </ISelectOption>
        }
      </ISelectContent>
    </ISelectMenu>

    <div class="flex justify-end gap-2">
      <button iButton variant="secondary" size="md" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
      <button iButton size="md" [disabled]="!selectedOrganization()" (click)="selectOrganization()">
        {{ t("common.next") }}
      </button>
    </div>
  </div>
</ng-container>
